import {Injectable} from '@angular/core';
import {Menu} from './dto/Menu';

@Injectable()
export class MenuService {

  menuItems: Array<Menu>;

  constructor() {
    this.menuItems = [];
  }

  addMenu(items: Array<Menu>): void {
    items.forEach((item) => {
      if (!item.hide) {
        this.menuItems.push(item);
      }
    });
  }

  getMenu(): Array<Menu> {
    return this.menuItems;
  }

  resetMenu(): void {
    this.menuItems = [];
  }

}
